import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from './getBaseQuery';
import { GetResearchObjectiveRequest, GetResearchObjectiveResponse } from './types/TResearchObjective';

const URL_Prefix = '/research_objective';

export const researchObjectiveService = createApi({
    reducerPath: 'researchObjectiveService',
    baseQuery: getBaseQuery,
    tagTypes: ['ResearchObjective'],
    endpoints: (builder) => ({
        getResearchObjective: builder.query<GetResearchObjectiveResponse, GetResearchObjectiveRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/selector/`,
                method: 'GET',
            }),
        }),
    }),
});

export const {
    useGetResearchObjectiveQuery,
    useLazyGetResearchObjectiveQuery,
} = researchObjectiveService;